module.exports = __webpack_public_path__ + "static/media/coach.88ab5151.svg";